<template>
  <v-container class="frequency-display-container pa-0">
    <v-row row dense wrap class="pa-0">
      <v-col class="col-12 pb-0">
        <label class="application-heading">Alert Triggers</label>
      </v-col>
      <v-col class="col-12 pt-0">
        <div class="ml-3">{{ selectedValue.adverb }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import lodashFind from "lodash/find";
import { FREQUENCY_OPTIONS } from "@/common/constants/alert.js";

export default {
  name: "FrequencyDisplay",
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  computed: {
    selectedValue() {
      const results = lodashFind(FREQUENCY_OPTIONS, {
        id: this.value.id,
      });
      return results || {};
    },
  },
};
</script>
<style scoped>
.frequency-display-container {
  padding: 5px;
}
label {
  font-size: 16px;
}
</style>
